module.exports = __webpack_public_path__ + "media/ppc/topics-that-matter-2e21a681.png";